import React, { createContext, useContext } from "react";
import { useNotificationBadge } from "../hooks/useNotificationBadge";

const NotificationBadgeContext = createContext();

export const NotificationBadgeProvider = ({ children }) => {
  const notificationBadgeData = useNotificationBadge();
  
  return (
    <NotificationBadgeContext.Provider value={notificationBadgeData}>
      {children}
    </NotificationBadgeContext.Provider>
  );
};

export const useNotificationBadgeContext = () => {
  const context = useContext(NotificationBadgeContext);
  if (!context) {
    throw new Error('useNotificationBadgeContext must be used within a NotificationBadgeProvider');
  }
  return context;
};
